import { LandingPageCoverImage } from '@1po/1po-bff-fe-spec/generated/backoffice/landing_page_cover/model/LandingPageCoverImage';

import { APP_NAMESPACE } from 'app/App.constants';
import { SearchData } from 'utils';

export const LANDING_PAGE_COVER_NAMESPACE = `${APP_NAMESPACE}/LANDING_PAGE_COVER`;

export const GET_LANDING_PAGE_COVERS_REQUEST = `${LANDING_PAGE_COVER_NAMESPACE}/GET_LANDING_PAGE_COVERS_REQUEST`;
export const UPLOAD_LANDING_PAGE_COVER_REQUEST = `${LANDING_PAGE_COVER_NAMESPACE}/UPLOAD_LANDING_PAGE_COVER_REQUEST`;
export const SET_LANDING_PAGE_COVER_ACTIVE_REQUEST = `${LANDING_PAGE_COVER_NAMESPACE}/SET_LANDING_PAGE_COVER_ACTIVE_REQUEST`;

export const COVER_STATUS_ACTIVE = 'ACTIVE';
export const COVER_STATUS_INACTIVE = 'INACTIVE';

export interface LandingPageCoverState {
  covers: SearchData<LandingPageCoverImage[]>;
  isUploading: boolean;
}
